module.exports = __webpack_public_path__ + "img/9.ad3fc9c7.jpg";